import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { State } from 'react-automata'
import ButtonArrow from '../../components/ButtonArrow'
import Button from '../../components/Button'
import Item from '../../components/Item'
import ItemImage from '../../components/ItemImage'
import CharacterKeoniNoSlippersImage from '../../assets/images/character--keoni-no-slippers@3x.png'
import CharacterPluggyForwardArmDownImage from '../../assets/images/character--pluggy-forward-arm-down@3x.png'
import RoomLiving from '../../components/RoomLiving'
import { media } from '../../theme'

const RoomContainer = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  max-width: ${p => p.theme.mediaSizes.extraLarge}px;
  position: relative;
  width: 70%;
  z-index: 2;
  transform: scale(0.75);

  @media (min-height: 768px) {
    transform: none;
  }

  ${media.greaterThan('large')`
    width: 65%;
  `};
`

const TipWrapper = styled.div`
  margin: 0 auto;
  max-width: ${p => p.theme.mediaSizes.small * 0.8}px;
  width: 100%;
`

const ItemAbove = styled(Item)`
  z-index: 10;
`

const NextRoomContainer = styled.div`
  animation: ${p => p.theme.animation.sideToSide} 2s infinite;
  animation-timing-function: cubic-bezier(0.455, 0.03, 0.515, 0.955);
  align-items: center;
  bottom: ${p => p.theme.spacing(5)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 ${p => p.theme.spacing(2)} ${p => p.theme.spacing(2)} 0;
  position: absolute;
  right: 0;
  z-index: 3;

  @media (min-height: 900px) and (min-width: ${p =>
      p.theme.mediaSizes.medium}px) {
    bottom: ${p => p.theme.spacing(6)};
  }
`

const StyledButtonWide = styled(Button)`
  padding-left: ${p => p.theme.spacing(2.5)};
  padding-right: ${p => p.theme.spacing(2.5)};
`

const CharacterShadow = styled.div`
  background-color: rgba(0, 0, 0, 0.15);
  border-radius: 50%;
  bottom: 0;
  height: 15%;
  position: absolute;
  transform: translateY(25%);
  width: 100%;
  z-index: -1;
`

export default class LivingRoomRoomDesktop extends Component {
  static propTypes = {
    pendingHighlightIds: PropTypes.arrayOf(PropTypes.string),
    successHighlightIds: PropTypes.arrayOf(PropTypes.string),
    onItemClick: PropTypes.func.isRequired,
    clickedAllItems: PropTypes.bool,
  }

  static defaultPropTypes = {
    clickedAllItems: false,
  }

  render() {
    const {
      animateIds,
      clickedAllItems,
      onItemClick,
      pendingHighlightIds,
      renderTip,
      successHighlightIds,
      onRoomClear,
      roomProgressData,
      buttonText,
    } = this.props

    return [
      clickedAllItems && (
        <NextRoomContainer key="living-room__room__next-room-container--desktop">
          <StyledButtonWide
            onClick={event => onRoomClear(event, roomProgressData)}
            size="large"
            pulse={true}
            to="/kitchen"
            buttonText={buttonText}
          />
        </NextRoomContainer>
      ),
      <RoomContainer key="living-room__room__room-container">
        <RoomLiving
          animateIds={animateIds}
          pendingHighlightIds={pendingHighlightIds}
          successHighlightIds={successHighlightIds}
          onItemClick={onItemClick}
        >
          <Item width={13} left={-8.75} bottom={20.5}>
            <ItemImage src={CharacterPluggyForwardArmDownImage} />
            <CharacterShadow />
          </Item>
          <Item width={12} left={94} bottom={19.5}>
            <ItemImage src={CharacterKeoniNoSlippersImage} />
            <CharacterShadow />
          </Item>
          <ItemAbove left={81.3} bottom={50} width={37.5}>
            <TipWrapper>
              {clickedAllItems &&
                renderTip('living-room__conclusion', {
                  character: false,
                  closable: false,
                })}
            </TipWrapper>
          </ItemAbove>
          <ItemAbove left={-24.9} bottom={50} width={45.5}>
            <TipWrapper>
              <State value="guide">
                {renderTip('living-room__guide', { character: false })}
              </State>
              <State value="entertainmentSystem">
                {renderTip('living-room__entertainmentSystem', {
                  character: false,
                })}
              </State>
              <State value="blinds">
                {renderTip('living-room__blinds', { character: false })}
              </State>
              <State value="ac">
                {renderTip('living-room__ac', { character: false })}
              </State>
              <State value="powerStrip">
                {renderTip('living-room__powerStrip', {
                  character: false,
                })}
              </State>
              <State value="chloe">
                {renderTip('living-room__chloe', {
                  character: false,
                })}
              </State>
            </TipWrapper>
          </ItemAbove>
        </RoomLiving>
      </RoomContainer>,
    ]
  }
}



// WEBPACK FOOTER //
// ./src/pages/living-room/_LivingRoomRoom.desktop.js